<template>

  <div class="bg-container page">
    <img class="bg-img" src="/img/login/login.png">
    <div class="bg-wrapper">
      <div class="register">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon name="arrow-left" color="#fff" @click="back()"/>
          </template>
        </van-nav-bar>
        <div class="wrapper">
     
          <div class="title">{{$t("auth.register")}}</div>
          <div class="loginForm">
            <van-field v-model="username"  clearable input-align="center" class="input"  :placeholder="$t('auth.username_place')" />
            <van-field
                v-model="password"
                :type="passwordType"
                input-align="center"
                class="input"
                :placeholder="$t('auth.pwd_place')">
              <template slot="right-icon">
                <van-icon :name=" passwordType === 'password' ? 'closed-eye':'eye-o'" @click="switchPasswordType"/>
              </template>
            </van-field>
            <div class="input phone-row">
              <div class="phone-row__dial" @click="showCountryPicker = true">
                <span class="phone-row__flag">{{ selectedCountry.flag }}</span>
                <span class="phone-row__code">+{{ selectedCountry.dial }}</span>
                <van-icon name="arrow-down" />
              </div>
              <van-field
                v-model="phone"
                type="tel"
                clearable
                input-align="left"
                class="phone-row__input"
                :placeholder="$t('setting.mobile_place')"
              />
            </div>
            <van-field v-model="code"  clearable input-align="center" class="input"  :placeholder="$t('auth.invite_code_place')" />

            <van-popup v-model="showCountryPicker" position="bottom" round :style="{ height: '60%' }">
              <van-picker
                show-toolbar
                :title="$t('setting.country')"
                :columns="pickerColumns"
                :default-index="defaultCountryIndex"
                @cancel="showCountryPicker = false"
                @confirm="onCountryConfirm"
              />
            </van-popup>
            <!-- <div class="agreement">
              <van-checkbox v-model="checked" />
              <span class="agreement-text">{{$t("auth.agreement_place")}}</span>
            </div> -->
            <van-button class="login-btn"   type="primary" size="normal" @click="doRegister()">{{$t("auth.register")}}</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { countries, findCountry } from '../../assets/countries.js'

export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: true,
      username: '',
      code: '',
      lang: 'en',
      password: this.inputValue,
      passwordType: 'password',
      phone: '',
      countries: countries,
      selectedCountry: findCountry('US'),
      showCountryPicker: false,
    };
  },
  computed: {
    pickerColumns(){
      return this.countries.map(c => c.flag + '  ' + c.name + '  (+' + c.dial + ')')
    },
    defaultCountryIndex(){
      var idx = this.countries.findIndex(c => c.iso === this.selectedCountry.iso)
      return idx < 0 ? 0 : idx
    }
  },
  mounted(){
    this.lang = localStorage.getItem("lang") || 'en';
    this.detectCountry();
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back(){
      return window.history.back();
    },
    onCountryConfirm(value, index){
      this.selectedCountry = this.countries[index] || this.selectedCountry;
      this.showCountryPicker = false;
    },
    detectCountry(){
      var saved = localStorage.getItem('detected_country');
      if(saved){
        var c = findCountry(saved);
        if(c) this.selectedCountry = c;
        return;
      }
      try{
        fetch('https://ipapi.co/json/').then(function(r){ return r.json(); }).then((data)=>{
          var iso = data && data.country_code ? data.country_code : null;
          if(iso){
            localStorage.setItem('detected_country', iso);
            var c = findCountry(iso);
            if(c) this.selectedCountry = c;
          }
        }).catch(function(){ /* offline or blocked */ });
      }catch(e){ /* fallback to default country */ }
    },
    doRegister() {
      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if(!this.phone || !String(this.phone).trim()){
        this.$toast.fail(this.$t("setting.mobile_place"));
        return false;
      }
      if(this.code === "" || this.code === null || this.code === undefined){
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      if(!this.checked){
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }
      this.$http({
        method: 'post',
        data:{
          username:this.username,
          password:this.password,
          code:this.code,
          lang: this.lang,
          phone: String(this.phone).trim(),
          country_code: this.selectedCountry.dial,
          country_iso: this.selectedCountry.iso
        },
        url: 'member_register'
      }).then(res=>{
          if(res.code === 200){
            this.$toast.success(res.msg);
            localStorage.setItem('token',res.data)
            this.$router.push("Home")
          }else {
            this.$toast.fail(res.msg);
          }
      })
    }
  },
  created() {
    if(localStorage.getItem('token')){
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.register{
  height: 100%;
}
.bg-container .bg-wrapper .register .nav-bar{
  background: 0 0
}
.register .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container{
  margin: 0 auto;
  width: 45%;
}
.logo-container .logo-wrapper{
  position: relative;
  padding-bottom: 62.5%;
}
.logo-container .logo-wrapper .logo-img{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}
.register .wrapper .title{
  line-height: 100px;
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 5px;
}
.register .wrapper .loginForm{
  padding: 60px;
}
.register .wrapper .loginForm .input{
  padding: 10px 20px;
  margin-top: 35px;
  border-radius: 50px;
  text-align: center;
  line-height: 70px;
  font-size: 30px;
  color: #4e4e4e;
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}
::v-deep .van-icon {
  font-size: 50px;
}
.register .wrapper .loginForm .reset-text{
  margin: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.register .wrapper .loginForm .reset-text span{
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 15px;
}
.register .wrapper .loginForm .register-text{
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.register .wrapper .loginForm .register-text span{
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 20px;
}
.register .wrapper .loginForm .login-btn{
  margin-top: 30px;
  width: 100%;
  height: 100px;
  border-radius: 50px;
  color: #fff;
  background: linear-gradient(90deg, #6529c9, #cc2996);;
  font-size: 30px;
  font-weight: bolder;
  border: none;
}
.register .wrapper .loginForm .agreement{
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.register .wrapper .loginForm .agreement .agreement-text{
  margin-left: 10px;
  font-size: 25px;
  color: #fff;
  font-weight: 500;
  line-height: 30px;
}
::v-deep .agreement .van-icon {
  font-size: 30px;
}
::v-deep .agreement .van-checkbox__icon {
  font-size: 38px;
}
::v-deep .agreement .van-checkbox__icon--checked .van-icon {
  color: #fff;
  border-color: rgb(126, 86, 120);
  background-color: rgb(126, 86, 120);
}
.register .wrapper .loginForm .input.phone-row{
  display: flex;
  align-items: center;
  padding: 0 10px;
  background: #fff;
}
.phone-row__dial{
  display: flex;
  align-items: center;
  padding: 0 18px;
  height: 70px;
  border-right: 1px solid #eee;
  color: #4e4e4e;
  font-size: 28px;
}
.phone-row__flag{
  font-size: 32px;
  margin-right: 8px;
}
.phone-row__code{
  margin-right: 6px;
  font-weight: 600;
}
.phone-row__dial .van-icon{
  font-size: 28px;
  margin-left: 6px;
}
.phone-row__input{
  flex: 1;
  padding: 10px 20px !important;
  background: transparent !important;
}
::v-deep .phone-row__input .van-field__control{
  font-size: 30px;
  color: #4e4e4e;
  text-align: left;
}
</style>
